import type { ComputePaths, ComputeResourceKind } from '../types';

export function getCpuPrefix(paths: ComputePaths): string {
  return paths.cpuCards.replace(/\.physicalCards$/, '');
}

/** 厂商设备元数据统一路径（计价 / 非计价字段相同，仅展示不同） */
export function resolveVendorDevicePath(resourceKind: ComputeResourceKind, paths: ComputePaths): string {
  if (resourceKind === 'cpu') return paths.cpuPricing;
  if (resourceKind === 'memory') return paths.memoryPricing;
  if (resourceKind === 'gpu') return paths.gpu;
  return paths.bandwidthPricing;
}
